<template>
  <div v-if="betPeriod" class="px-0">
    <!-- Loop durch alle Spiele -->
    <div v-for="rm in betPeriod.realMatches"
         v-bind:key="rm.id"
         :set="bet = getBetByRealMatch(rm)">

      <!-- Startzeit des Spiels -->
      <div class="mt-2">
        <div class="ps-2" v-if="newStartTimeAndChallenge(rm)">
          {{ rm.challenge | cropChallenge }} |
          {{ rm.start | calendar }}
        </div>
      </div>

      <!-- Pro Spiel eine Reihe -->
      <div class="card-sakali row mx-1 px-1 px-md-2">

        <!-- Teams -->
        <div class="col-7 col-md-8 my-auto p-0">
          <div class="d-flex pb-1">
            <real-team-emblem :team="rm.team1" :height="30" style="max-width: 30px;"/>
            <span class="ms-1 text-truncate">{{ rm.team1 }}</span>
          </div>
          <div class="d-flex text-truncate">
            <real-team-emblem :team="rm.team2" :height="30"/>
            <span class="ms-1">{{ rm.team2 }}</span>
          </div>
        </div>

        <!-- Quoten -->
        <div class="col-2 col-md-2">
          <div class="text-nowrap">
                        <span class="d-inline-block border border-dark text-dark text-center small"
                              style="width:1rem">1</span>
            <span :class="getQuotaClassForTendency(1, bet, rm)" class="mx-0">
                            {{ rm.quotaTeam1 | float }}
                        </span>
          </div>
          <div class="text-nowrap" v-if="!rm.koMode">
            <div class="d-inline-block border border-dark text-dark text-center small" style="width:1rem">
              &times;
            </div>
            <span :class="getQuotaClassForTendency(0, bet, rm)" class="mx-0">
                            {{ rm.quotaDraw | float }}
                        </span>
          </div>
          <div v-else>-</div>
          <div class="text-nowrap">
                        <span class="d-inline-block border border-dark text-dark text-center small"
                              style="width:1rem">2</span>
            <span :class="getQuotaClassForTendency(2, bet, rm)"
                  style="width: 5rem;">
                            {{ rm.quotaTeam2 | float }}
                        </span>
          </div>
        </div>

        <!-- Panel mit Tippmöglichkeit anzeigen -->
        <div class="col-3 col-md-2 d-flex justify-content-around pe-0 noselect" v-if="!rm.bettingClosed">
          <div v-for="col in ['t1', 'm', 't2']" :key="col + '_' + rm.id">
            <div class="d-block mt-0 ms-auto link hover-sakali-primary text-center" v-if="col !== 'm'"
                 @click="adjustBet(rm, 1, col === 't1', true)">
              <fas icon="chevron-up"
                   size="lg">

              </fas>
            </div>
            <div class="mx-auto d-block text-center" v-if="col !== 'm'">
              <input class="form-control"
                     :value="(bet && (col === 't1' ? bet.goalsTeam1 : bet.goalsTeam2) !== '-1') ? (col === 't1' ? bet.goalsTeam1 : bet.goalsTeam2) : ''"
                     type="number"
                     minlength="2"
                     maxlength="2"
                     style="padding: 3px; text-align: center; user-select: all;"
                     onfocus="this.select();"
                     onclick="this.select();"
                     @input="setBet(rm, $event.target.value, col === 't1')"/>
            </div>
            <div class="mb-0 me-auto d-block link hover-sakali-primary text-center" v-if="col !== 'm'"
                 @click="adjustBet(rm, -1, col === 't1', true)">
              <fas icon="chevron-down"
                   size="lg"></fas>
            </div>
            <!-- Spalte zwischen den Ergebnissen -->
            <div v-if="col === 'm'" class="mt-4">
              <span class="font-weight-bold mx-1">:</span>
            </div>
          </div>
        </div>

        <!-- Tippen nicht mehr möglich - Resultatspanel anzeigen -->
        <div class="col-3 col-md-2 p-1" v-else>
          <div class="d-block h5 mt-1 text-end text-danger" v-if="rm.state == 'CANCELED'">
            <span class="d-md-none">abges.</span>
            <span class="d-none d-md-block">abgesagt</span>
          </div>
          <div class="d-block h2 text-end" v-else>
                        <span :class="{'text-sakali-primary': rm.state==='RUNNING'}">
                            {{ rm.goalsTeam1 >= 0 ? rm.goalsTeam1 : '-' }}:{{
                            rm.goalsTeam2 >= 0 ? rm.goalsTeam2 : '-'
                          }}
                        </span>
          </div>
          <div class="d-block text-end text-nowrap">
                        <span v-if="bet">
                            {{ bet.goalsTeam1 }}:{{ bet.goalsTeam2 }}
                        </span>
            <span v-else>
                            - : -
                        </span>
            <span v-if="bet && bet.correct" class="text-success">
                            <fas :class="{'text-info':bet.exact}" icon="check" class="ms-1"></fas>
                        </span>
            <span v-else class="text-danger">
                            <fas icon="times" class="ms-1"></fas>
                        </span>
          </div>
        </div><!-- Resultatspanel -->
      </div><!-- Spielreihe -->
    </div><!-- Loop durch Spiele -->

    <!-- Zusammenfassung Tippscheinergebnis -->
    <div class="row mt-3 mx-3 border-top pt-3" v-if="betSlip && (betPeriod.running || betPeriod.finished)">
      <div class="col-6">
        Rang des Tippscheins
        <div class="progress px-0 mt-2 border-sakali-primary">
          <div class="progress-bar bg-sakali-primary text-dark" role="progressbar"
               :style="{width: betSlip.rankPercentage + '%'}"
               aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
            {{ betSlip.rank }}.
          </div>
        </div>
      </div>
      <div class="col-6 text-end">
        <div>
          Punkte: <span
            :class="{'text-sakali-primary': betPeriod.running && !betPeriod.finished}">{{
            betSlip.points | float
          }}</span>
        </div>
        <div>
          Auszahlung: <span
            :class="{'text-sakali-primary': betPeriod.running && !betPeriod.finished}">{{
            betSlip.payOff | kies
          }}</span>
        </div>
        <div
            v-if="betSlip.karmaBonus > 0">
          Karma-Bonus: {{ betSlip.karmaBonus | kies }}
        </div>
      </div>
    </div>
    <div class="mt-4">
      <BetSlipAdminActions :bet-period-id="betPeriod.id"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import sakaliApi from '../../sakali-api'
import RealTeamEmblem from '../RealTeamEmblem'
import BetSlipAdminActions from "../../admin/bet/BetSlipAdminActions.vue";

export default {
  props: {
    betPeriod: Object
  },
  data() {
    return {
      betSlip: null,
      currentDate: null,
      currentChallenge: null
    }
  },
  computed: {
    ...mapGetters(['loggedIn']),
    payOff() {
      let res = 0;
      this.betPeriod.realMatches.forEach(rm => {
        let bet = this.getBetByRealMatch(rm);
        if (bet && bet.correct) {
          res += bet.points;
        }
      })
      return res;
    }
  },
  methods: {
    ...mapActions(['messageAction', 'handleErrorAction']),
    getQuotaClassForTendency(tendency, bet, rm) {
      if (rm.state == 'FINISHED' || rm.state == 'RUNNING') {
        if (bet && bet.tendency == tendency) {
          if (bet.correct)
            return 'text-success'
          else
            return 'text-danger'
        }
      } else {
        if (bet && bet.tendency == tendency)
          return 'text-primary'
      }
      return '';
    },
    getBetByRealMatch(realMatch) {
      if (this.betSlip) {
        for (let i = 0; i < this.betSlip.bets.length; i++) {
          if (this.betSlip.bets[i].realMatchId == realMatch.id)
            return this.betSlip.bets[i]
        }
      }
      return null;
    },
    newStartTimeAndChallenge(rm) {
      let idx = this.betPeriod.realMatches.indexOf(rm);
      if (idx == 0)
        return true;
      else {
        const prevRm = this.betPeriod.realMatches[idx - 1]
        return (prevRm.start != rm.start || prevRm.challenge != rm.challenge)
      }
    },
    setBet: function (realMatch, value, home) {
      console.log('' + value)
      let bet = this.getBetByRealMatch(realMatch);
      let oldVal = bet ? (home ? bet.goalsTeam1 : bet.goalsTeam2) : 0;
      this.adjustBet(realMatch, value - oldVal, home, false)
    },
    adjustBet: function (realMatch, summand, home, spinnerInput) {
      let bet = this.getBetByRealMatch(realMatch);
      let oldVal = bet ? (home ? bet.goalsTeam1 : bet.goalsTeam2) : 0;
      if (!bet) {
        bet = {
          goalsTeam1: spinnerInput ? 0 : (home ? summand : 0),
          goalsTeam2: spinnerInput ? 0 : (!home ? summand : 0),
          realMatchId: realMatch.id
        };
        this.betSlip.bets.push(bet)
      } else {
        if (home) {
          bet.goalsTeam1 = Math.max(bet.goalsTeam1 + summand, 0)
        } else {
          bet.goalsTeam2 = Math.max(bet.goalsTeam2 + summand, 0)
        }
      }
      // test draw if koMode
      if (bet.goalsTeam1 === bet.goalsTeam2 && realMatch.koMode) {
        if (home) {
          bet.goalsTeam1 += summand;
          if (bet.goalsTeam1 < 0)
            bet.goalsTeam1 = oldVal;
        } else {
          bet.goalsTeam2 += summand;
          if (bet.goalsTeam2 < 0)
            bet.goalsTeam2 = oldVal;
        }
      }
      // post the bet
      sakaliApi.post('/betslips/' + this.betSlip.id, bet).then(response => {
        this.addOrReplaceBet(response.data);
        this.$emit('betSlip', this.betSlip)
      }).catch(error => {
        this.handleErrorAction('handleErrorAction', error)
      });
    },
    addOrReplaceBet(bet) {
      let foundBetIdx = this.betSlip.bets.findIndex(b => b.realMatchId == bet.realMatchId)
      if (foundBetIdx >= 0) {
        this.betSlip.bets.splice(foundBetIdx, 1, bet);
      } else
        this.betSlip.bets.push(bet)
    },
    loadBetSlip() {
      // load the user's betslip for this period
      sakaliApi.get('/betslips', {
        params: {
          bp: this.betPeriod.id
        }
      }).then(response => {
        if (response.data) {
          this.betSlip = response.data;
          this.$emit('betSlip', this.betSlip)
        }
      }).catch(error => {
        this.handleErrorAction('BetSlip.loadBetSlip()' + error)
      });
    }
  },
  watch: {
    betPeriod: {
      handler(newVal) {
        if (this.loggedIn && newVal)
          this.loadBetSlip()
      },
      immediate: true
    }
  },
  filters: {
    cropChallenge(c) {
      return c.split('/', 2)[1]
    }
  },
  components: {
    BetSlipAdminActions,
    RealTeamEmblem
  }
}
</script>

<style scoped>
.hover-sakali-primary:hover {
  color: #FF9900;
}
</style>
